import React from 'react';
import { TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { modulesGeneral_Values, moduleValues } from '../../../../../Shared/utils';

import ModuleValueSelect from './ModuleValueSelect'

import { FormControl } from '@material-ui/core';

export default function Condition2({ line, moduleNumber, handleChangeLine, handleRemoveLine }) {
  const { t } = useTranslation();

  const isValue = ['==', '!=', '<', '>'].includes(line.condition);
  //const isAndOr = ['AND', 'OR'].includes(cond.condition);

  // console.log("16 - moduleValues=", moduleValues[moduleNumber]);
  // console.log("17 - line=", line);


  const genericValues = [
    "result", "result data", "closing code", "param1", "param2"
  ]

  const values = (moduleNumber === -1) ? modulesGeneral_Values/*.map(value => t('scenarios.module_general.' + value))*/ : genericValues.concat(moduleValues[moduleNumber]);

  //return (<div>...</div>);

  const cond = {
    xtra_desc: line.desc,
    condition: line.condition,
    xtra_value: line.value
  }

  return (
    <div className="module__condition">

      <select
        className="singleSelect"
        name={'operator' + line.seq}
        value={line.extra ?? '0'}
        onChange={e => handleChangeLine(line, 'extra', e.target.value)}
        disabled={line.extra === ''}
      >
        {/* <option hidden value="0">{t('scenarios.conditions.operator')}</option> */}
        {line.extra === '' &&
          <option value="">{''}</option>
        }
        <option value="OR">{t('scenarios.conditions.operators.OR').replace(/(\u2000)/g, '')}</option>
        <option value="AND">{t('scenarios.conditions.operators.AND').replace(/(\u2000)/g, '')}</option>
      </select>

      <select
        className="singleSelect"
        name={'leftP' + line.seq}
        value={line.first ?? '0'}
        onChange={e => handleChangeLine(line, 'first', e.target.value)}
      >
        <option value="0">{''}</option>
        <option value="1">{'﴾'}</option>
        <option value="2">{'﴾﴾'}</option>
        <option value="3">{'﴾﴾﴾'}</option>
      </select>

      <ModuleValueSelect
        cond={cond}
        values={values}
        onChangeValue={o => {
          handleChangeLine(line, 'desc', o);
        }}
      />

      <select
        className="singleSelect"
        name={'operator' + line.seq}
        value={line.condition ?? '0'}
        onChange={e => handleChangeLine(line, 'condition', e.target.value)}
      >
        <option hidden value="0">{line.condition ? '' : t('scenarios.conditions.operator')}</option>
        <option value="==">{t('scenarios.conditions.operators.==')}</option>
        <option value="!=">{t('scenarios.conditions.operators.!=')}</option>
        {(moduleNumber === 1126 && cond.xtra_desc === "Nb Disks wiped") ? (
          <>
            <option value=">">{t('scenarios.conditions.operators.>')}</option>
            <option value="<">{t('scenarios.conditions.operators.<')}</option>
            <option value="ANY">{t('scenarios.conditions.operators.ANY')}</option>
          </>
        ) : (
          <>
        <option value="ANY">{t('scenarios.conditions.operators.ANY')}</option>
        <option value="NONE">{t('scenarios.conditions.operators.NONE')}</option>
        <option value="EMPTY">{t('scenarios.conditions.operators.EMPTY')}</option>
          </>
        )
        }
      </select>

      <TextField
        variant='standard'
        disabled={!isValue}
        value={(isValue && line.value) ? line.value : ''}
        title={(isValue && line.value) ? line.value : ''}
        onChange={e => handleChangeLine(line, 'value', e.target.value)}
        placeholder={(isValue && line.value) ? t('scenarios.conditions.value') : ''}
      />

      <select
        className="singleSelect"
        name={'leftP' + line.seq}
        value={line.last ?? '0'}
        onChange={e => handleChangeLine(line, 'last', e.target.value)}
      >
        <option value="0">{''}</option>
        <option value="1">{'﴿'}</option>
        <option value="2">{'﴿﴿'}</option>
        <option value="3">{'﴿﴿﴿'}</option>
      </select>


      <div className="actions">
        <span
          className="material-icons remove"
          title={t('scenarios.lines.remove')}
          onClick={() => handleRemoveLine(line)}
        >
          remove_circle_outline
        </span>
        {/* <span className="material-icons drag-handle">drag_handle</span> */}
      </div>
    </div >
  );
}
